import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-slate-50">
      {/* Header - NoticePage와 동일한 디자인 */}
      <div className="w-full h-20 bg-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.01)]">
        <div className="max-w-[1920px] mx-auto px-4 h-full relative flex items-center">
          <Link to="/" className="md:block hidden">
            <div className="w-auto h-8 left-[40px] top-[26px] absolute whitespace-nowrap text-[#1A253F] text-[14px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
          {/* Mobile Header */}
          <Link to="/" className="md:hidden block w-full">
            <div className="w-full h-7 text-center text-[#1A253F] text-[18px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full h-px bg-white border border-slate-200"></div>

      {/* Main Content - DetailPage 디자인 요소 참조 */}
      <div className="w-[760px] mx-auto relative pt-8">
        {/* 헤더 섹션 */}
        <div className="mt-8">
          <div className="text-slate-800 text-4xl font-extrabold font-['Pretendard'] leading-9">
            개인정보 보호정책
          </div>
          <div className="w-full h-px mt-8 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>
        </div>

        {/* 본문 내용 */}
        <div className="mt-8 bg-white rounded-sm outline outline-1 outline-slate-200">
          <div className="p-8">
            {/* 1. 개인정보의 수집 및 이용 목적 */}
            <div className="mb-8">
              <h2 className="text-[#1e2c49] text-xl font-bold font-['Pretendard'] leading-9 mb-4">
                1. 개인정보의 수집 및 이용 목적
              </h2>
              <div className="w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6"></div>
              <p className="text-[#1e2c49] text-[19px] font-medium mb-4 leading-relaxed">
                부산항신항시설관리센터는 다음과 같은 목적으로 개인정보를 수집하고 이용합니다:
              </p>
              <ul className="list-disc pl-6 text-[#6b7684] text-lg font-medium space-y-2">
                <li>시설 예약 및 관리</li>
                <li>포트빌 입주 신청 및 관리</li>
                <li>회원 관리 및 서비스 제공</li>
                <li>공지사항 및 안내사항 전달</li>
              </ul>
            </div>

            {/* 2. 수집하는 개인정보 항목 */}
            <div className="mb-8">
              <h2 className="text-[#1e2c49] text-xl font-bold font-['Pretendard'] leading-9 mb-4">
                2. 수집하는 개인정보 항목
              </h2>
              <div className="w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6"></div>
              <p className="text-[#1e2c49] text-[19px] font-medium mb-4 leading-relaxed">
                수집하는 개인정보 항목은 다음과 같습니다:
              </p>
              <ul className="list-disc pl-6 text-[#6b7684] text-lg font-medium space-y-2">
                <li>필수항목: 이름, 이메일, 전화번호, 소속</li>
              </ul>
            </div>

            {/* 3. 개인정보의 보유 및 이용기간 */}
            <div className="mb-8">
              <h2 className="text-[#1e2c49] text-xl font-bold font-['Pretendard'] leading-9 mb-4">
                3. 개인정보의 보유 및 이용기간
              </h2>
              <div className="w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6"></div>
              <p className="text-[#1e2c49] text-[19px] font-medium leading-relaxed">
                개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 
                단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에서 정한 일정한 기간 동안 개인정보를 보관합니다.
              </p>
            </div>

            {/* 4. 개인정보의 파기절차 및 방법 */}
            <div className="mb-8">
              <h2 className="text-[#1e2c49] text-xl font-bold font-['Pretendard'] leading-9 mb-4">
                4. 개인정보의 파기절차 및 방법
              </h2>
              <div className="w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6"></div>
              <p className="text-[#1e2c49] text-[19px] font-medium leading-relaxed">
                개인정보는 목적이 달성된 후에는 내부 방침 및 관련 법령에 의한 정보보호 사유에 따라 일정 기간 저장된 후 파기됩니다.
              </p>
            </div>

            {/* 5. 개인정보 보호책임자 */}
            <div>
              <h2 className="text-[#1e2c49] text-xl font-bold font-['Pretendard'] leading-9 mb-4">
                5. 개인정보 보호책임자
              </h2>
              <div className="w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6"></div>
              <p className="text-[#1e2c49] text-[19px] font-medium mb-6 leading-relaxed">
                부산항신항시설관리센터는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 
                개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
              </p>
              <div className="bg-[#f2f6fb] rounded-sm p-6">
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <span className="text-[#6b7684] text-lg font-medium">개인정보 보호책임자: </span>
                    <span className="text-[#1e2c49] text-[19px] font-semibold">김태근</span>
                  </div>
                  <div>
                    <span className="text-[#6b7684] text-lg font-medium">연락처: </span>
                    <span className="text-[#1e2c49] text-[19px] font-semibold">051-890-7400</span>
                  </div>
                  <div>
                    <span className="text-[#6b7684] text-lg font-medium">이메일: </span>
                    <span className="text-[#1e2c49] text-[19px] font-semibold">tkkim@bnfc.or.kr</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 푸터 */}
      <footer className="bg-[#0E2039] h-[340px] md:h-[210px] mt-[100px]">
        <div className="max-w-[1380px] mx-auto px-4 sm:px-8 md:px-16 pt-[40px] md:pt-[54px]">
          <div className="flex flex-col md:flex-row justify-between">
            <div>
              <h4 className="text-[16px] md:text-[24px] font-semibold text-white/80 font-pretendard mb-[41px]">
                부산항신항시설관리센터
              </h4>
              <div className="flex flex-col md:flex-row items-start md:items-center gap-[8px] md:gap-[24px]">
                <p className="text-[14px] md:text-[15px] font-medium text-[#64AAC6] font-pretendard">Contact</p>
                <p className="text-[12px] font-light text-white/40 font-pretendard">
                  부산광역시 강서구 신항로 96-87
                </p>
                <div className="flex items-center gap-[8px]">
                  <p className="text-[12px] font-light text-white/40 font-pretendard">
                    대표번호:051-890-7400
                  </p>
                  <p className="text-[12px] font-light text-white/40 font-pretendard">
                    FAX:051-831-5344
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-[8px] md:gap-[44px] mt-[20px] md:mt-0">
              <Link to="/notices" className="text-[14px] md:text-[15px] font-bold text-white font-pretendard">공지사항</Link>
              <Link to="/privacy" className="text-[14px] md:text-[15px] font-bold text-white font-pretendard">개인정보처리방침</Link>
              <Link to="/email-policy" className="text-[14px] md:text-[15px] font-bold text-white font-pretendard">이메일무단수집거부</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage; 